import api from '../../api/auth'

const state = {
    user: null,
    stateIsReady: false,
    preferences: null
}

const getters = {
    user: (state) => {
        return state.user
    },

    isLoggedIn: (state) => {
        return state.user !== null && state.user !== 'undefined'
    },

    notifications: (state) => {
        if (state.user == null) {
            return []
        }

        return state.user.notifications
    },

    unreadChats: (state) => {
        if (state.user == null) {
            return 0
        }

        return state.user.unreadChatMessages
    },

    stateIsReady: (state) => {
        return state.stateIsReady
    },

    preferences: (state) => {
        return state.preferences
    },

    avatar: (state) => {
        return get(state.user, 'avatar', '/img/pictures/avatar-1.jpg')
    },

    can: state => ability => get(state.user, 'permissions', []).includes(ability),

    hasBadge: state => badge => collect(get(state.user, 'badges', [])).where('id', badge.id).isNotEmpty()
}

const actions = {
    async loadUser({commit}) {
        try {
            let response = await api.loadUser()

            commit('update', response.data)

            Quiz.$emit('user-loaded')
            return response
        } catch (error) {
            commit('update', {user: null})
            Quiz.$emit('user-load-error', error)
            return error
        }

    },
    async refreshStats({commit}) {
        try {
            let response = await api.loadStat()

            commit('updateUserStat', response.data)

            Quiz.$emit('user-stat-refreshed')
        } catch (error) {
            Quiz.$emit('user-stat-refresh-error', error)
        }
    },
    async setUserData({commit}, { field, value }) {
        try {
            await api.updateUserData(field, value)
            commit('updateUserData', {field ,value})
        } catch (error) {
            Quiz.$emit('user-profile-update-error', error)
        }
    },
    async setUserAvatar({commit}, { id, avatar }) {
        try {
            await api.updateUserData('avatar_id', id)

            commit('updateUserAvatar', {id, avatar})
        } catch (error) {
            Quiz.$emit('user-avatar-update-error', error)
        }
    },
    async refreshUnreadChats({commit}) {
        try {
            let response = await api.refreshUnreadChats()

            commit('updateUnreadChats', response.data.unreadChats)
        } catch (error) {
        }
    },
    async refreshVirtualBalance({commit}) {
        try {
            let response = await api.loadVirtualBalance()

            commit('updateVirtualBalance', response.data.virtualBalance)
        } catch (error) {
        }
    },
    async loadUserPowerUps({commit}) {
        try {
            let response = await api.loadUserPowerUps()

            commit('updateUserPowerUps', response.data.data)
        } catch (error) {
        }
    }
}

const mutations = {
    update(state, data) {
        state.user = data.user
        state.stateIsReady = true

        let animation = Cookies.get('quiz-animation');
        if (typeof animation == 'undefined') {
            animation = true;
        }

        state.preferences = {
            'animation': get(data, 'user.animation', animation),
            'profileColor': get(data, 'user.profileColor', 'pink')
        }
    },
    updateUserStat(state, data) {
        state.user['stats'] = data;
    },
    updateUserData(state, {field, value}) {
        state.user[field] = value;
    },
    updateUserAvatar(state, {id, avatar}) {
        state.user.avatarId = id;
        state.user.avatar = avatar;
    },
    updatePreferences(state, {field, value}) {
        state.preferences[field] = value;
    },
    insertNotification(state, {notification}) {
        state.user.notifications.unshift(notification)
    },
    readNotification(state, {notification}) {
        state.user.notifications = state.user.notifications.map((notificationItem) =>
            notificationItem.id === notification.id ? {...notificationItem, read_at: true} : notificationItem
        )
    },
    updateUnreadChats(state, {unreadChats}) {
        state.user.unreadChatMessages = unreadChats
    },
    updateVirtualBalance(state, balance) {
        state.user.balance = balance
    },
    updateUserPowerUps(state, powerUps) {
        state.user.power_ups = powerUps
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
